import { TipToTenderFromContainer } from '../forms/trip-to-tender-form-container';

export const TenderTransportContainer = () => {
  return <TipToTenderFromContainer />;
};
